import React, { useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";

import { Content_SAL2110_R01 } from "./Content_SAL2110_R01";
import { SearchSection_SAL2110_R01 } from "./SearchSection_SAL2110_R01";
import { useSAL2110_R01Store } from "./Store_SAL2110_R01";
import { CustomTotalTable_SAL2110_R01 } from "./CustomTotalTable_SAL2110_R01";
import { BrandTotalTable_SAL2110_R01 } from "./BrandTotalTable_SAL2110_R01";
import { ItemTotalTable_SAL2110_R01 } from "./ItemTotalTable_SAL2110_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL2110_R01Dto } from "./Dto_SAL2110_R01";
import { useMouseContent } from "src/utils/mouse/mouseContent";

export const Container_SAL2110_R01 = () => {
	const { initData } = useSAL2110_R01Store();
	const { setMessage } = useUiuxStore();

	const customGridRef = useRef<AgGridReact<SAL2110_R01Dto>>(null);
	const brandGridRef = useRef<AgGridReact<SAL2110_R01Dto>>(null);
	const itemGridRef = useRef<AgGridReact<SAL2110_R01Dto>>(null);
	const gridContainerRef = useRef<HTMLDivElement>(null);
	const gridRightContainerRef = useRef<HTMLDivElement>(null);
	const brandGridContainerRef = useRef<HTMLDivElement>(null);
	const isCustomGridResizing = useRef(false);
	const isBrandGridResizing = useRef(false);

	const customGridResizer = {
		code: 'SAL2110_R01',
		type: 'width',
		storageKey: 'SAL2110_R01-custom-grid-split-width',
		min: 5,
		max: 80,
		default: 20,
	} as const;

	const brandGridResizer = {
		code: 'SAL2110_R01',
		type: 'width',
		storageKey: 'SAL2110_R01-brand-grid-inner-split-width',
		min: 5,
		max: 80,
		default: 25,
	} as const;

	const {
		splitValue: customGridSplitValue,
		handleMouseDown: handleCustomGridMouseDown,
	} = useMouseContent({
		resizer: customGridResizer,
		isResizing: isCustomGridResizing,
		containerRef: gridContainerRef,
		infoRef: gridRightContainerRef,
	});

	const {
		splitValue: brandGridSplitValue,
		handleMouseDown: handleBrandGridMouseDown,
	} = useMouseContent({
		resizer: brandGridResizer,
		isResizing: isBrandGridResizing,
		containerRef: gridRightContainerRef,
		infoRef: brandGridContainerRef,
	});

	const {
		fetchData,
		handleExcelClick,
	} = Content_SAL2110_R01({
		customGridRef,
		brandGridRef,
		itemGridRef,
		setMessage,
	});

	return (
		<div className={`content-container`}>
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={undefined}
				onDeleteClick={undefined}
				onSaveClick={undefined}
				onPrintClick={undefined}
				onExcelClick={handleExcelClick}
				onInitClick={() => { initData(); }}
			/>
			<SearchSection_SAL2110_R01 />

			<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={gridContainerRef}>
				<div
					className="h-full"
					style={{ width: `${customGridSplitValue}%` }}
				>
					<CustomTotalTable_SAL2110_R01 gridRef={customGridRef} />
				</div>
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleCustomGridMouseDown('LR', e.nativeEvent)}
					onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				/>
				<div
					className="h-full flex gap-[4px] min-w-0"
					style={{ width: `${100 - customGridSplitValue}%` }}
					ref={gridRightContainerRef}
				>
					<div className="h-full" style={{ width: `${brandGridSplitValue}%` }} ref={brandGridContainerRef}>
						<BrandTotalTable_SAL2110_R01 gridRef={brandGridRef} />
					</div>
					<div
						className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleBrandGridMouseDown('LR', e.nativeEvent)}
						onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
					/>
					<div className="h-full" style={{ width: `${100 - brandGridSplitValue}%` }}>
						<ItemTotalTable_SAL2110_R01 gridRef={itemGridRef} />
					</div>
				</div>
			</div>
			<Message />
		</div>
	);
};
